import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../assets/ai-center-logo.png";
import { useLanguage } from "../context/LanguageContext";

function FooterComponent() {
  const { t } = useLanguage();

  return (
    <footer className="footer py-5">
      <Container>
        <Row>
          {/* Prva kolona: Logo i podaci o tvrtki */}
          <Col lg={4} md={4} sm={6} className="mb-4">
            <Link to="/">
              <img src={logo} alt="AI Center Lipik logo" style={{ maxWidth: "130px" }} />
            </Link>
            <p className="footer-inscription mt-3">
              <strong>{t("footer.companyName")}</strong><br />
            </p>
            <p className="footer-text">
              {t("footer.companyAgency")}<br />
              {t("footer.companyAddress")}<br />
              {t("footer.companyOib")}<br />
            </p>
          </Col>

          {/* Druga kolona: Navigacijski linkovi */}
          <Col lg={4} md={4} className="mb-4">
            <h5 className="text-uppercase footer-text mb-3">{t("footer.navHeader")}</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/analiticar-strojno-ucenje-uzivo" className="footer-link">
                  {t("footer.progOnline")}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/ai-programer-uzivo" className="footer-link">
                  {t("footer.progLive")}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/ai-strucnjak-online" className="footer-link">
                  {t("footer.progExpert")}
                </Link>
              </li>
              <li className="mb-2 mt-3 pt-2 border-top border-secondary border-opacity-25">
                <Link to="/u-medijima" className="footer-link">
                  {t("footer.inMedia")}
                </Link>
              </li>
            </ul>
          </Col>

          {/* Treća kolona: Kontakt podaci */}
          <Col lg={4} md={4} className="mb-4">
            <h5 className="text-uppercase footer-text mb-3">{t("footer.contactHeader")}</h5>
            <p className="footer-text">
              {t("footer.phone")}
            </p>
            <p className="footer-text">
              {t("footer.email")}
            </p>
            <p className="footer-text mt-3">
              <Link
                to="/privatnost"
                className="footer-link"
                style={{ fontSize: "0.85rem", opacity: 0.8 }}
              >
                {t("footer.privacyLink")}
              </Link>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default FooterComponent;